/**
 * [T149-PR5-FE] Insights skin shared helpers.
 *
 * Re-exports PR3's `_shared` helpers and adds an insights-specific
 * `readInsightsConfig` typed reader for `widget.config` shapes that vary
 * by skin (`groupBy`, `dateRange`, `txnType`, `top`).
 *
 * @module dashboard/widgets/skins/insights/_shared
 */
export {
  skinTestId,
  SkinLoadingRows,
  SkinLoadingBars,
  SkinLoadingLine,
  SkinLoadingDonut,
  SkinLoadingRadar,
  SkinLoadingHeatmap,
  SkinLoadingProgress,
  SkinLoadingList,
  SkinLoadingKpi,
  SkinEmptyState,
  SkinErrorState,
  SkinComingSoonState,
  useSkinFrameProps,
} from '../_shared';

export const INSIGHTS_PALETTE = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
  'hsl(var(--chart-6))',
] as const;

/**
 * Defensive reader for `widget.config` — the shape varies per skin and the
 * Custom Dashboard editor may pass partial / legacy fields.
 */
export function readInsightsConfig<T extends Record<string, unknown>>(
  raw: unknown,
  defaults: T,
): T {
  if (raw == null || typeof raw !== 'object') return defaults;
  const r = raw as Record<string, unknown>;
  return { ...defaults, ...r } as T;
}
